import { render } from "./BanUserPopup.vue?vue&type=template&id=7f34da93&scoped=true&ts=true"
import script from "./BanUserPopup.vue?vue&type=script&lang=ts"
export * from "./BanUserPopup.vue?vue&type=script&lang=ts"

import "./BanUserPopup.vue?vue&type=style&index=0&id=7f34da93&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f34da93"]])

export default __exports__